module.exports = __webpack_public_path__ + "static/img/3.19fdc03.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/2/sp/3.png
// module id = Z1+d
// module chunks = 0